import { AxiosError } from 'axios';
import { ArrowLeft } from 'lucide-react';

export function BackLink({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      className="flex items-center gap-1 text-sm text-muted-foreground transition-colors hover:text-foreground"
      onClick={onClick}>
      <ArrowLeft className="h-4 w-4" />
      Back
    </button>
  );
}

export function ErrorBanner({ message }: { message: string }) {
  return <div className="rounded-md bg-destructive/10 px-3 py-2 text-sm text-destructive">{message}</div>;
}

export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof AxiosError) {
    const detail = err.response?.data?.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  }
  return fallback;
}

export function PasswordHint() {
  return (
    <p className="text-xs text-muted-foreground">
      At least 8 characters with upper- and lowercase letters, a number, and a symbol.
    </p>
  );
}

export function SignInFooter({ onSignIn }: { onSignIn: () => void }) {
  return (
    <div className="border-t pt-4 text-center text-sm text-muted-foreground">
      Already have an account?{' '}
      <button type="button" className="font-medium text-primary underline-offset-4 hover:underline" onClick={onSignIn}>
        Sign in
      </button>
    </div>
  );
}
